import {Component, computed, inject, input, output} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {FormsModule} from '@angular/forms';
import {Select} from "primeng/select";
import {TipoObra} from '@core/models/tipo-obra';
import {TipoObraService} from '@core/services/tipo-obra.service';

@Component({
  selector: 'app-input-select-tipo-obra',
  imports: [
    Select,
    FormsModule,
  ],
  templateUrl: './input-select-tipo-obra.component.html',
  styleUrl: './input-select-tipo-obra.component.css'
})
export class InputSelectTipoObra {
  private static nextId = 0;
  protected readonly fieldId = `tipo-obra-${++InputSelectTipoObra.nextId}`;

  initialValue = input<number | null>();
  selectionChange = output<number | null>();
  readonly = input<boolean | null>(false);
  labelClass = input<string | null>();
  showRequiredSpan = input<boolean>(false);
  private readonly tipoObraService: TipoObraService = inject(TipoObraService);

  protected tiposObraOptions = toSignal(
    this.tipoObraService.getTiposObra(), {
      initialValue: [] as TipoObra[]
    }
  );

  protected tipoObraSelecionada = computed(() =>
    (this.tiposObraOptions() ?? []).find(t => t.id === this.initialValue()) ?? null
  );

}
